import { Environment } from '../app/shared/models/environment';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://b2bqa.katdev.com',
  msClientId: 'acf3d299-d39d-4445-8a30-86a8efcc218c',
};
